import dataToolsConfig from '../components/Navigation/data-tools-config';

export const getDataToolLabelKey = (pathname: string) =>
    dataToolsConfig.find(({ path }) => pathname === path || pathname.startsWith(`${path}/`))
        ?.labelKey;
